__turbopack_export_value__({
  "className": "inter_337e7cb6-module__uEWyba__className",
});
